export const shouldUseExternalAppointmentLink = (
  allowedCodes: string[],
  storeGroupCode: string | null,
  appointmentUrl?: string | null,
): boolean => {
  return !!appointmentUrl && !!storeGroupCode && allowedCodes.includes(storeGroupCode);
};